import { Matrix } from "./Matrix";
import { Time } from "./Time";
import * as Constants from "./Constants";

export class Earth {
    /** Equatorial radius of the Earth in km */
    static readonly RADIUS = 6378.137;

    /** Dimensionless form factor (WGS84) */
    static readonly FORMFACTOR = 298.257223563;

    /** flattening */
    static readonly F = 1 / Earth.FORMFACTOR;

    /** first eccentricity squared */
    static readonly ESQ = (2 - Earth.F) * Earth.F;

    /** Rotation rate in radians/s */
    static readonly ROTATION_RATE = Constants.TWOPI / 86164.091;

    /** Gravitational constant times mass in km³/s² */
    static readonly GM = 398600.5;

    static gha(t: number): number {
        let tu = Time.getCenturiesSinceJ2000(t);
        let gmst = 24110.54841 + (8640184.812866 + (0.093104 - 0.0000062 * tu) * tu) * tu;
        gmst += (t % 86400000) * 0.001;
        gmst = (gmst / 13750.987) % Constants.TWOPI;
        if (gmst < 0) gmst += Constants.TWOPI;
        return gmst;
    }

    static getPrecessionMatrix(t: number): Matrix {
        let T = Time.getCenturiesSinceJ2000(t);
        let T2 = T * T;
        let T3 = T2 * T;

        let eta = (0.6406161 * T + 0.0000839 * T2 + 0.000005 * T3) * Constants.DEGTORAD;
        let zeta = (0.6406161 * T + 0.0003041 * T2 + 0.0000051 * T3) * Constants.DEGTORAD;
        let theta = (0.556753 * T - 0.0001185 * T2 - 0.0000116 * T3) * Constants.DEGTORAD;

        let ce = Math.cos(eta);
        let se = Math.sin(eta);
        let cz = Math.cos(zeta);
        let sz = Math.sin(zeta);
        let ct = Math.cos(theta);
        let st = Math.sin(theta);

        return new Matrix([ce * ct * cz - se * sz, -se * ct * cz - ce * sz, -st * cz, ce * ct * sz + se * cz, -se * ct * sz + ce * cz, -st * sz, ce * st, -se * st, ct]);
    }
}


// WEBPACK FOOTER //
// ./src/Earth.ts